// extracted by mini-css-extract-plugin
export default {"ws":"app-base_ws__0Pwze","container":"app-base_container__Hh0uj","layoutContainer":"app-base_layoutContainer__mKX4k","toast":"app-base_toast__bE3OG"};